import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Checkbox, Input, Textarea } from "../../../ui/inputs/Input";
import useTable from "../../../components/useTable";

const headCells = [
  {
    id: "numero",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nº",
    textAlign: "center",
  },
  {
    id: "fecha",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fecha",
    textAlign: "center",
  },
  {
    id: "monto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Monto",
    textAlign: "center",
  },
  {
    id: "tipo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Tipo",
    textAlign: "center",
  },
  {
    id: "estado",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Estado",
    textAlign: "center",
  },
];

export default function CuadernoObras({ setTabla, setShow, show }) {
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { 
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Cuaderno de Obras</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap d-flex">
        <div className="col-2 m-0 mb-2 p-0">
          <Input label="Código:" />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label="Nº del Contrato:" />
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 border-azul rounded">
          <legend className="float-none w-auto m-0">Cuenta de Obra</legend>
          <div className="col-12 m-0 mb-2 p-0 d-flex">
            <div className="col m-0 p-0">
              <Input label="Sector:" />
            </div>
            <div className="col m-0 p-0 pl-2">
              <Input label="Prog:" />
            </div>
            <div className="col m-0 p-0 pl-2">
              <Input label="SubPr:" />
            </div>
            <div className="col m-0 p-0 pl-2">
              <Input label="Proy:" />
            </div>
            <div className="col m-0 p-0 pl-2">
              <Input label="Act:" />
            </div>
          </div>
          <div className="col-12 m-0 p-0 d-flex">
            <div className="col m-0 p-0">
              <Input label="Part:" />
            </div>
            <div className="col m-0 p-0 pl-2">
              <Input label="Gen:" />
            </div>
            <div className="col m-0 p-0 pl-2">
              <Input label="Espec:" />
            </div>
            <div className="col m-0 p-0 pl-2">
              <Input label="SubEsp:" />
            </div>
            <div className="col m-0 p-0 pl-2">
              <Input label="Aux:" />
            </div>
          </div>
        </fieldset>
        <div className="col-8 m-0 mb-2 p-0">
          <Textarea style={{ height: 70 }} />
        </div>
        <div className="col-4 m-0 p-0 pl-2">
          <Input
            label="Monto de la Obra:"
            inputClassName="text-end"
            placeholder="0.00"
          />
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex border-azul rounded">
          <legend className="float-none w-auto m-0">
            Datos del Contratista
          </legend>
          <div className="col-6 m-0 p-0">
            <Input label="Nombre o Razón Social:" />
          </div>
          <div className="col-2 m-0 p-0 pl-2">
            <Input label="RIF:" />
          </div>
          <div className="col-4 m-0 p-0 pl-2">
            <Input label="Representante:" />
          </div>
        </fieldset>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex flex-wrap align-items-center border-azul rounded">
          <legend className="float-none w-auto m-0">Fecha de acta</legend>
          <div className="col-auto m-0 p-0 pr-2">
            <Input label="Inicio:" type="date" />
          </div>
          <div className="col-auto m-0 p-0 pr-2">
            <Input label="Terminación:" type="date" />
          </div>
          <div className="col-auto m-0 p-0 pr-2">
            <Input label="Provisional:" type="date" />
          </div>
          <div className="col-auto m-0 p-0 pr-2">
            <Input label="Definitiva:" type="date" />
          </div>
          <div className="col-auto m-0 p-0">
            <Checkbox label="Finalizar Obra" />
          </div>
        </fieldset>
        <ul className="nav nav-tabs col-12 m-0 mb-2 p-0" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="valuacionesObras-tab"
              data-bs-toggle="tab"
              data-bs-target="#valuacionesObras-tab-pane"
              type="button"
              role="tab"
              aria-controls="valuacionesObras-tab-pane"
              aria-selected="true"
            >
              Registro de Valuaciones de Obras
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="prorrogaObras-tab"
              data-bs-toggle="tab"
              data-bs-target="#prorrogaObras-tab-pane"
              type="button"
              role="tab"
              aria-controls="prorrogaObras-tab-pane"
              aria-selected="false"
            >
              Registro de Prorroga de Obras
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="paralizacionesReinicio-tab"
              data-bs-toggle="tab"
              data-bs-target="#paralizacionesReinicio-tab-pane"
              type="button"
              role="tab"
              aria-controls="paralizacionesReinicio-tab-pane"
              aria-selected="false"
            >
              Registro de Paralizaciones y Reinicio de Obras
            </button>
          </li>
        </ul>
        <div className="tab-content col-12 m-0 p-0" id="myTabContent">
          <div
            className="tab-pane fade show active col-12 m-0 p-0"
            id="valuacionesObras-tab-pane"
            role="tabpanel"
            aria-labelledby="valuacionesObras-tab"
            tabindex="0"
          >
            <div className="col-12 m-0 p-0 d-flex">
              <div className="col-6 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <tr key={index}></tr>
                      ))}
                  </tbody>
                </TblContainer>
              </div>
              <div className="col-6 m-0 p-0 pl-2">
                <div className = "col-12 m-0 mb-2 p-0" >
                  <Input label = 'Monto Total del Contrato:' inputClassName = "text-end" placeholder = "0.00"/>
                </div>
                <div className = "col-12 m-0 mb-2 p-0" >
                  <Input label = 'Total Valuaciones + Anticipos:' inputClassName = "text-end" placeholder = "0.00"/>
                </div>
                <div className = "col-12 m-0 p-0" >
                  <Input label = 'Porcentaje Pagado:' inputClassName = "text-end" placeholder = "0.00"/>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="prorrogaObras-tab-pane"
            role="tabpanel"
            aria-labelledby="prorrogaObras-tab"
            tabindex="0"
          >
            2 ...
          </div>
          <div
            className="tab-pane fade"
            id="paralizacionesReinicio-tab-pane"
            role="tabpanel"
            aria-labelledby="paralizacionesReinicio-tab"
            tabindex="0"
          >
            3 ...
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
